import Immutable from 'immutable';
import {
  FETCH_MEMBERSHIP_REQUEST, FETCH_MEMBERSHIP_SUCCESS, FETCH_MEMBERSHIP_ERROR
} from '../constants/ActionTypes';

export const STATUS_REGISTERED = 'registered';
export const STATUS_PRE_REGISTERED = 'pre_registered';
export const STATUS_NOT_REGISTERED = 'not_registered';
export const STATUS_NO_KAKAO_ACCOUNT = 'no_kakao_account';

const initialState = Immutable.Map();
export default function membership(state = initialState, action) {
  switch (action.type) {
    case FETCH_MEMBERSHIP_REQUEST:
      return state;
    case FETCH_MEMBERSHIP_SUCCESS: {
      const { result } = action;
      return state.merge(Immutable.fromJS(result));
    }
    case FETCH_MEMBERSHIP_ERROR:
      return state;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/membership.js